import React from "react";
import { FormControl } from "react-bootstrap";

const TextArea = ({ ele, formik, value = "" }) => (
  <FormControl as="textarea" rows={3} value={value} onChange={formik.handleChange} {...(ele.dataElement || {})}
               name={ele.name} />
);

export default TextArea;
